import { CpTeamUser, CpUserListFilters } from './user.model';

export const CpUserActionTypes = {
  loadUsers: '[CP Users] Load Users',
  loadUsersSuccess: '[CP Users] Load Users Success',
  loadUsersFailure: '[CP Users] Load Users Failure',
  setFilters: '[CP Users] Set Filters',
  inviteUser: '[CP Users] Invite User',
  inviteUserSuccess: '[CP Users] Invite User Success',
  inviteUserFailure: '[CP Users] Invite User Failure',
  updateUser: '[CP Users] Update User',
  updateUserSuccess: '[CP Users] Update User Success',
  updateUserFailure: '[CP Users] Update User Failure',
  removeUser: '[CP Users] Remove User',
  removeUserSuccess: '[CP Users] Remove User Success',
  removeUserFailure: '[CP Users] Remove User Failure',
} as const;

export interface CpUserAction {
  type: (typeof CpUserActionTypes)[keyof typeof CpUserActionTypes];
  payload?: unknown;
}

export const cpUserActions = {
  loadUsers: (): CpUserAction => ({ type: CpUserActionTypes.loadUsers }),
  loadUsersSuccess: (users: CpTeamUser[]): CpUserAction => ({
    type: CpUserActionTypes.loadUsersSuccess,
    payload: users,
  }),
  loadUsersFailure: (error: string): CpUserAction => ({
    type: CpUserActionTypes.loadUsersFailure,
    payload: error,
  }),
  setFilters: (filters: Partial<CpUserListFilters>): CpUserAction => ({
    type: CpUserActionTypes.setFilters,
    payload: filters,
  }),
  inviteUserSuccess: (user: CpTeamUser): CpUserAction => ({
    type: CpUserActionTypes.inviteUserSuccess,
    payload: user,
  }),
  updateUserSuccess: (user: CpTeamUser): CpUserAction => ({
    type: CpUserActionTypes.updateUserSuccess,
    payload: user,
  }),
  removeUserSuccess: (userId: string): CpUserAction => ({
    type: CpUserActionTypes.removeUserSuccess,
    payload: userId,
  }),
};
